import { createSelector } from 'reselect'
import { getUserInfo } from '../getUserInfo'

export const getUserPackage = createSelector(
  getUserInfo,
  user => user && Array.isArray(user.packages) && user.packages.length && user.packages[0] ? user.packages[0] : null
)
